<template>
  <div class="table">
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="年份" prop="year">
                    <el-date-picker v-model="queryCondition.year" value-format="yyyy" format="yyyy" type="year" placeholder="选择年" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="季度" prop="quarter">
                    <ic-select clearable table="TT_QSPI_FSPI" field="QUARTER" @change="quarterChange" v-model="queryCondition.quarter" :allValues="true" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="月份" prop="month">
                    <ic-select clearable table="TT_QSPI_FSPI" field="MONTH" :excludes="excludesValue" v-model="queryCondition.month" :allValues="true" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="提交日期从" prop="fromTime">
                    <el-date-picker style="width: 100%" v-model="queryCondition.fromTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="提交日期至" prop="toTime">
                      <el-date-picker style="width: 100%" v-model="queryCondition.toTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-table ref="plxTable" :data="tableData" max-height="500" border highlight-current-row>
        <el-table-column align="center" label="提交日期" prop="submitTime" min-width="100"></el-table-column>
        <el-table-column align="center" label="评价期" prop="scoreStage" min-width="100"></el-table-column>
        <el-table-column align="center" label="Grade" prop="gradeI18n" min-width="100"></el-table-column>
        <el-table-column align="center" label="数量">
          <el-table-column align="center" :label="'Water \n Safety & \n Quality'" prop="waterSafetyAndQuality" min-width="90"></el-table-column>
          <el-table-column align="center" :label="'3rd Party \n Audit'" prop="threeRdPartyAudit" min-width="90"></el-table-column>
          <el-table-column align="center" :label="'Gov`t \n Audit & \n Sampling'" prop="govtAuditAndSampling" min-width="90"></el-table-column>
          <el-table-column align="center" :label="'Gov`t FS \n Grading'" prop="govtFsGrading" min-width="90"></el-table-column>
          <el-table-column align="center" :label="'CSAT \n Quality'" prop="csatQuality" min-width="90"></el-table-column>
          <el-table-column align="center" :label="'Consumer \n Feedback \n All (SC)'" prop="consumerFeedbackAllSc" min-width="90"></el-table-column>
          <el-table-column align="center" :label="'Consumer \n Feedback \n (Ops)'" prop="consumerFeedbackOps" min-width="90"></el-table-column>
        </el-table-column>
        <el-table-column align="center" label="Percentage">
          <el-table-column align="center" :label="'Water \n Safety & \n Quality'" prop="waterSafetyAndQualityPer" min-width="90"></el-table-column>
          <el-table-column align="center" :label="'3rd Party \n Audit'" prop="threeRdPartyAuditPer" min-width="90"></el-table-column>
          <el-table-column align="center" :label="'Gov`t \n Audit & \n Sampling'" prop="govtAuditAndSamplingPer" min-width="90"></el-table-column>
          <el-table-column align="center" :label="'Gov`t FS \n Grading'" prop="govtFsGradingPer" min-width="90"></el-table-column>
          <el-table-column align="center" :label="'CSAT \n Quality'" prop="csatQualityPer" min-width="90"></el-table-column>
          <el-table-column align="center" :label="'Consumer \n Feedback \n All (SC)'" prop="consumerFeedbackAllScPer" min-width="90"></el-table-column>
          <el-table-column align="center" :label="'Consumer \n Feedback \n (Ops)'" prop="consumerFeedbackOpsPer" min-width="90"></el-table-column>
        </el-table-column>
        <el-table-column align="center" label="月度GC" prop="gc" min-width="100"></el-table-column>
        <el-table-column align="center" label="月度品质分数" prop="qualityScore" min-width="120"></el-table-column>
        <el-table-column align="center" label="月度问卷数" prop="questionScore" min-width="120"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" label="备注" prop="remark" min-width="120"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" label="修改原因" prop="modifyReason" min-width="120"></el-table-column>
        <el-table-column align="center" label="状态" prop="statusI18n" min-width="90"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" label="更新人" prop="updateUser" min-width="120"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" label="更新时间" prop="updateDate" min-width="120"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store/index'
import IcSelect from "@/components/common/icSelect";
import fspiApi from "@/api/fspi/index";
import commonFunction from "@/utils/dataTableUtils";
export default {
  name: '',
  components: {
    IcSelect,
  },
  data() {
    return {
      isShow: false,
      activeName: "first",
      totalCount: 0,
      pages: 1,
      queryCondition: {
        status: "",
        year: "",
        quarter: "",
        month: "",
        toTime: "",
        fromTime: "",
        pageSize: 15,
        pageNum: 1,
      },
      tableData: [],
      excludesValue: []
    }
  },
  created() {
  },
  mounted() {

  },
  beforeRouteEnter(to, from, next) {
    console.log('to', to);
    console.log('from', from);
    if (from.path == '/qspiFSPI/detail') {
      next(vm => {
        vm.queryCondition.scoreStage = from.query.scoreStage;
        vm.queryData()
      })
    }
  },
  methods: {
    queryData() {
      fspiApi.queryHistory(this.queryCondition).then(res => {
        console.log('res', res);
        this.tableData = res.data.resultData;
        this.totalCount = res.data.totalCount;
      });
    },
    quarterChange(val) {
      console.log('val', val);
      if (val == 'Q1') {
        this.excludesValue = ['04', '05', '06', '07', '08', '09', '10', '11', '12']
      } else if (val == 'Q2') {
        this.excludesValue = ['01', '02', '03', '07', '08', '09', '10', '11', '12']
      } else if (val == 'Q3') {
        this.excludesValue = ['01', '02', '03', '04', '05', '06', '10', '11', '12']
      } else if (val == 'Q4') {
        this.excludesValue = ['01', '02', '03', '04', '05', '06', '07', '08', '09']
      } else {
        this.excludesValue = []
      }
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onSearch() {
      this.queryData()
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        status: "",
        year: "",
        quarter: "",
        month: "",
        toTime: "",
        fromTime: "",
        pageSize: 15,
        pageNum: 1,
      }
      this.queryCondition.scoreStage = this.$route.query.scoreStage;
      this.queryData();
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
